export default __webpack_public_path__ + "static/media/client-1.65d47d4c.png";